import {schema} from 'normalizr';

export const note = new schema.Entity(
  'note',
  {},
  { idAttribute: 'created_at' }
);

export const parentSitterNotes = { parent_sitter_notes: new schema.Array(note) }; // eslint-disable-line camelcase
